import { gql } from '@apollo/client';

export const SET_TOKEN_GROUP = gql`
  mutation SetTokenGroup($portfolioId: ID!, $tokenId: ID!, $groupId: ID) {
    setTokenGroup(portfolioId: $portfolioId, tokenId: $tokenId, groupId: $groupId)
  }
`;

export const CREATE_TOKEN_GROUP = gql`
  mutation CreateTokenGroup($portfolioId: ID!, $name: String!) {
    createTokenGroup(portfolioId: $portfolioId, name: $name)
  }
`;

export const RENAME_TOKEN_GROUP = gql`
  mutation RenameTokenGroup($portfolioId: ID!, $groupId: ID!, $name: String!) {
    renameTokenGroup(portfolioId: $portfolioId, groupId: $groupId, name: $name)
  }
`;

export const DELETE_TOKEN_GROUP = gql`
  mutation DeleteTokenGroup($portfolioId: ID!, $groupId: ID!) {
    deleteTokenGroup(portfolioId: $portfolioId, groupId: $groupId)
  }
`;

export const SET_TOKEN_GROUP_BY_COINGECKO_API_ID = gql`
  mutation SetTokenGroupByCoingeckoApiId($portfolioId: ID!, $coingeckoApiId: String!, $groupId: ID) {
    setTokenGroupByCoingeckoApiId(portfolioId: $portfolioId, coingeckoApiId: $coingeckoApiId, groupId: $groupId)
  }
`;

export const IMPORT_TOKEN_GROUPS_CSV = gql`
  mutation ImportTokenGroupsCSV($portfolioId: ID!, $csvData: String!) {
    importTokenGroupsCSV(portfolioId: $portfolioId, csvData: $csvData) {
      success
      error
      importedCount
      skippedCount
      warnings { rowNumber ticker message }
    }
  }
`;